document.addEventListener('DOMContentLoaded', function () {
  const freeGiftThreshold = 5000; // 50€ en centimes
  const freeGiftVariantId = 49619689046346;
  const container = document.getElementById('gift-message-container');

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateGiftMessage(cart) {
    if (!container) return;

    const total = cart.total_price;
    const hasGift = cart.items.some(i => i.variant_id === freeGiftVariantId);
    let message = '';

    if (total >= freeGiftThreshold || hasGift) {
      message = `<div style="background:#e3ffe3;border:2px solid #3cba3c;border-radius:8px;padding:1.5rem;font-size:1.2rem;max-width:600px;margin:0 auto;">
        🎉 <strong>Félicitations !</strong> Vous recevrez un <strong>Gua Sha Quartz Rose offert</strong> dans votre commande.
      </div>`;
    } else {
      const missing = freeGiftThreshold - total;
      message = `<div style="background:#fff7f0;border:2px dashed #f0c36d;border-radius:8px;padding:1.5rem;font-size:1.2rem;max-width:600px;margin:0 auto;">
        🎁 Il vous manque encore <strong>${formatPrice(missing)}</strong> pour recevoir votre <strong>Gua Sha Quartz Rose offert</strong> !
      </div>`;
    }

    container.innerHTML = message;
  }

  function enforceGiftLogic(cart) {
    const total = cart.total_price;
    const hasGift = cart.items.some(i => i.variant_id === freeGiftVariantId);

    if (total >= freeGiftThreshold && !hasGift) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: freeGiftVariantId, quantity: 1 })
      }).then(() => location.reload());
    }

    if (total < freeGiftThreshold && hasGift) {
      const giftItem = cart.items.find(i => i.variant_id === freeGiftVariantId);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 })
      }).then(() => location.reload());
    }

    // Si cadeau ajouté + de 1x
    cart.items.forEach(item => {
      if (item.variant_id === freeGiftVariantId && item.quantity > 1) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 1 })
        }).then(() => location.reload());
      }
    });
  }

  function disableGiftPlusButton() {
    document.querySelectorAll('[data-quantity-variant-id]').forEach(input => {
      if (parseInt(input.dataset.quantityVariantId) === freeGiftVariantId) {
        const plusButton = input.closest('.quantity')?.querySelector('button[name="plus"]');
        if (plusButton) {
          plusButton.disabled = true;
          plusButton.style.opacity = '0.5';
          plusButton.style.cursor = 'not-allowed';
        }
      }
    });
  }

  function refreshAll() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateGiftMessage(cart);
        enforceGiftLogic(cart);
        disableGiftPlusButton();
      });
  }

  refreshAll();

  // Ajout du rechargement léger après action modifiant le panier
  document.body.addEventListener('click', function (e) {
    const changed =
      e.target.closest('button[name="plus"]') ||
      e.target.closest('button[name="minus"]') ||
      e.target.closest('button[name="remove"]') ||
      e.target.closest('[href*="/cart/change?"][href*="quantity=0"]');

    if (changed) {
      // Rechargement forcé après délai pour garder cohérence
      setTimeout(() => location.reload(), 1000);
    }
  });
});
